import { useContext, useEffect } from "react";
import { SportsCampsContext } from "../context/sportscamps-context";

const CareTypeFilter = () => {
	const {
		dictionaryWords,
		sportsCamps,

		careTypeCounter,
		setCareTypeCounter,

		careTypeCode,
		setCareTypeCode,
		careTypeButtonActive,
		setCareTypeButtonActive,
	} = useContext(SportsCampsContext);

	useEffect(() => {
		if (sportsCamps.counters) {
			const careTypeCounters = [];
			sportsCamps.counters.forEach((Type) => {
				if (Type.Type === "careType") {
					const object = {};
					object["CareType"] = Type.CareTypeCode;
					object["Count"] = Type.Count;
					careTypeCounters.push(object);
				}
			});
			setCareTypeCounter(careTypeCounters);
		}
	}, [JSON.stringify(sportsCamps.counters)]);

	const careTypeFilterHandler = (event) => {
		if (careTypeCode === "") {
			setCareTypeCode(event.target.value);
			setCareTypeButtonActive(true);
		} else if (careTypeCode !== event.target.value) {
			setCareTypeCode(event.target.value);
			setCareTypeButtonActive(true);
		} else if (careTypeCode === event.target.value) {
			setCareTypeCode("");
			setCareTypeButtonActive(false);
		}
	};

	return (
		<div className="filter-section">
			<h3>{dictionaryWords.careType}</h3>
			<div key="INT">
				<button
					className={
						careTypeButtonActive && careTypeCode === "INT"
							? "active"
							: ""
					}
					id="0"
					value="INT"
					onClick={careTypeFilterHandler}
				>
					{dictionaryWords.withOvernightStay}
					<span>
						{careTypeCounter.length > 0 &&
							`(${careTypeCounter[0].Count})`}
					</span>
					<i className="fa fa-close"></i>
				</button>
			</div>
			<div key="EXT - Lunch">
				<button
					className={
						careTypeButtonActive && careTypeCode === "EXT - Lunch"
							? "active"
							: ""
					}
					id="1"
					value="EXT - Lunch"
					onClick={careTypeFilterHandler}
				>
					{dictionaryWords.withoutOvernightStayWithoutLunch}
					<span>
						{careTypeCounter.length > 0 &&
							`(${careTypeCounter[1].Count})`}
					</span>
					<i className="fa fa-close"></i>
				</button>
			</div>
			<div key="EXT + Lunch">
				<button
					className={
						careTypeButtonActive && careTypeCode === "EXT + Lunch"
							? "active"
							: ""
					}
					id="2"
					value="EXT + Lunch"
					onClick={careTypeFilterHandler}
				>
					{dictionaryWords.withoutOvernightStayWithLunch}
					<span>
						{careTypeCounter.length > 0 &&
							`(${careTypeCounter[2].Count})`}
					</span>
					<i className="fa fa-close"></i>
				</button>
			</div>
		</div>
	);
};

export default CareTypeFilter;
